<template>
  <div class="accountSafe-bd">
    <div class="info wrapper">
      <h1>{{ $t('accountSafe.iSynergyzhang_hao') }}</h1>
      <div class="box">
        <ul>
          <li>
            <div class="label">{{ $t('accountSafe.mi_ma') }}</div>
            <div class="tip">{{ $t('accountSafe.jydqghmmlqszfhzmrylz') }}</div>
            <div class="set">
              <i class="icon icon-tishi"></i>
              <span>{{ $t('accountSafe.yi_she_zhi') }}</span>
            </div>
            <div class="col"></div>
            <div class="btn round" @click="changePwd">{{ $t('Common.com_modify') }}</div>
          </li>
          <li>
            <div class="label">{{ $t('Common.com_email') }}</div>
            <div class="tip">{{ $t('accountSafe.yymmzhykzwiSynergyzh') }}</div>
            <div class="set" :class="{ not: !userInfo.email }">
              <i class="icon icon-tishi"></i>
              <span>{{ !!userInfo.email ? $t('accountSafe.yi_she_zhi') : $t('accountSafe.dai_she_zhi') }}</span>
            </div>
            <div class="col"></div>
            <div class="btn round" v-if="!!userInfo.email" @click="changeEmail">{{ $t('Common.com_modify') }}</div>
            <div class="btn" v-else @click="changeEmail">{{ $t('Common.com_set') }}</div>
          </li>
          <li v-if="timeZoneIdList.length > 1">
            <div class="label">{{ $t('accountSafe.ri_qi_yu_shi_jian') }}</div>
            <div class="tip">{{ $t('accountSafe.yyszxtrqxsgs') }}</div>
            <div class="set">
              <i class="icon icon-tishi"></i>
              <span>{{ $t('accountSafe.yi_she_zhi') }}</span>
            </div>
            <div class="col"></div>
            <div class="btn round" @click="changeDate">{{ $t('Common.com_modify') }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="bind wrapper">
      <h1>{{ $t('accountSafe.dsfzhbd') }}</h1>
      <div class="box">
        <ul>
          <li>
            <div style="margin-right: 12px">
              <img style="display: block; width: 40px; height: 40px" src="@/images/wechat.png" alt="" />
            </div>
            <div class="label">{{ $t('accountSafe.wei_xin') }}</div>
            <div class="tip">{{ $t('accountSafe.bdhkywxdliSynergy') }}</div>
            <div class="set" :class="{ not: !isBindWechat }">
              <i class="icon icon-tishi"></i>
              <span>{{ isBindWechat ? $t('accountSafe.yi_bang_ding') : $t('accountSafe.dai_bang_ding') }}</span>
            </div>
            <div class="col"></div>
            <div class="btn round" v-if="isBindWechat" @click="unbindWechatConfirm()">{{ $t('accountSafe.jie_bang') }}</div>
            <div class="btn" v-else @click="wxScanLogin(appId, 'bind')">{{ $t('accountSafe.bang_ding') }}</div>
          </li>
        </ul>
      </div>
    </div>
    <change-pwd-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false"></change-pwd-dialog>
    <change-email-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false"></change-email-dialog>
    <change-date-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false"></change-date-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import changeDateDialog from './children/change_date_dialog.vue';
import changePwdDialog from './children/change_pwd_dialog.vue';
import changeEmailDialog from './children/change_email_dialog.vue';

// i18n-lang-component
export default {
  name: 'accountSafe',
  components: { changeDateDialog, changePwdDialog, changeEmailDialog },
  data() {
    return {
      appId: '',
      isBindWechat: null,

      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
      dialogVisible2: false,
      dialogModel2: {},
      timeZoneIdList: [],
    };
  },
  mounted: function () {
    this.getLoginConfig();
    this.getBindList();
    this.getTimeZoneIdList();
  },
  methods: {
    getTimeZoneIdList: function () {
      this.$getJSON(apis.timeZoneGetCompanyList).then((res) => {
        this.timeZoneIdList = res.data;
      });
    },
    // 微信扫码登录
    wxScanLogin: function (appId, state = 'login') {
      const AuthUrl = 'https://open.weixin.qq.com/connect/qrconnect?';
      const redirectUri = encodeURI(`${window.location.origin}/wechatlogin`);
      const baseUrl = `${AuthUrl}appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_login`;
      const wxLoginUrl = `${baseUrl}&state=${state}#wechat_redirect`;
      window.location.href = wxLoginUrl;
    },
    // 获取登录配置
    getLoginConfig: function () {
      this.$getJSON(apis.NcConfig).then((res) => {
        this.appId = res.data.appId;
      });
    },
    // 获取绑定平台
    getBindList: function () {
      this.$getJSON(apis.ThirdPartyList).then((res) => {
        this.isBindWechat = !!res.data.find(t => t.provider === 'weixin');
      });
    },
    // 确认解绑弹窗
    unbindWechatConfirm: function () {
      this.$showConfirm(this, this.$t('accountSafe.nqdyjcwxbdm'))
        .then(() => {
          this.unbindWechat();
        })
        .catch(() => {});
    },
    // 解除绑定
    unbindWechat: function () {
      const provider = 'weixin';
      this.$postJSON(`${apis.ThirdPartyUnbind}/${provider}`, {}, true)
        .then(() => {
          this.isBindWechat = false;
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success'),
          });
        })
        .then(() => {});
    },
    // 修改地址
    changePwd() {
      this.dialogModel = {
        type: 'edit',
        title: this.$t('accountSafe.xiu_gai_mi_ma'),
      };
      this.dialogVisible = true;
    },
    // 修改邮箱
    changeEmail() {
      this.dialogModel1 = {
        type: 'edit',
        title: this.$t('accountSafe.xiu_gai_you_xiang'),
        row: this.userInfo,
      };
      this.dialogVisible1 = true;
    },
    changeDate() {
      this.dialogModel2 = {
        type: 'edit',
        title: this.$t('accountSafe.ri_qi_yu_shi_jian'),
      };
      this.dialogVisible2 = true;
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.accountSafe-bd {
  padding: 24px;
  .wrapper {
    background-color: #ffffff;
    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02);
    border-radius: 16px;
    padding: 24px;
    margin-bottom: 24px;
    h1 {
      line-height: 40px;
      height: 40px;
      font-weight: bold;
      color: #1a1a1a;
      font-size: 18px;
      margin-bottom: 24px;
    }
    .box {
      background: #f8f8f8;
      border-radius: 16px;
      padding: 8px 24px;
      ul li {
        display: flex;
        align-items: center;
        height: 88px;
        line-height: 88px;
        box-shadow: inset 0px -1px 0px #f0f0f0;
        &:last-child {
          box-shadow: none;
        }
        .label {
          min-width: 170px;
          font-size: 14px;
          font-weight: bold;
          color: #1a1a1a;
        }
        .tip {
          color: #4d4d4d;
          font-size: 12px;
          flex: 1;
          width: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .set {
          color: #00a0d9;
          height: 21px;
          line-height: 21px;
          font-size: 14px;
          &.not {
            color: #eb5a5a;
          }
          i.icon {
            font-size: 20px;
            margin-right: 5px;
            float: left;
            line-height: 19px;
          }
        }
        .col {
          margin: 0 16px;
          width: 1px;
          height: 18px;
          background-color: rgba(0, 0, 0, 0.1);
        }
        .btn {
          cursor: pointer;
          background-color: #ffad00;
          height: 37px;
          line-height: 38px;
          text-align: center;
          padding: 0 26px;
          font-weight: bold;
          font-size: 14px;
          color: #202945;
          border-radius: 37px;
          &.round {
            line-height: 36px;
            background-color: transparent;
            border: 1px solid #202945;
          }
        }
      }
    }
  }
}
</style>
